(function () {
  const nvznAppData = JSON.parse(document.getElementById('nvzn-app-data').textContent);
  if (!nvznAppData) return console.error('[NVZN] nvznAppData not found');
  log('[NVZN] nvznAppData:', nvznAppData);

  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }
    document.querySelectorAll('.nvzn3d-arbutton').forEach((button) => {
      button.addEventListener('click', function () {
        const selectedVariant = getSelectedVariant();
        if (!selectedVariant) return console.error('[NVZN] Unable to determine selected variant');
        const arImage = nvznAppData.product.arImage || null;
        const dimensions = extractDimensions(selectedVariant.option1);

        log('AR Image:', arImage);
        log('Dimensions:', dimensions);

        Nvzn3D.displayFloorPreview({
          clientId: nvznAppData.app.nvznFloorClientID,
          imageUrl: arImage,
          width: dimensions.width,
          length: dimensions.length,
          units: dimensions.units,
        });
      });
    });
  }

  function getSelectedVariant() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant') || nvznAppData.product.selectedOrFirstAvailableVariantID.toString();
    if (!variantId) return console.error('[NVZN] Unable to determine variant ID');
    const variant = nvznAppData.product.variants.find((v) => v.id.toString() === variantId);
    if (!variant) return console.error(`[NVZN] Variant with ID ${variantId} not found`);
    return variant || null;
  }

  function extractDimensions(sizeString) {
    // Remove 'ft' or 'feet' if present
    sizeString = sizeString.replace(/\b(ft|feet)\b/gi, '').trim();
    // Split on 'x' or '×' (unicode multiplication)
    const parts = sizeString.split(/\s*[x×]\s*/i);
    let width = null, length = null;
    if (parts.length === 2) {
      width = parseFloat(parts[0]);
      length = parseFloat(parts[1]);
    }
    return {
      width,
      length,
      units: 'ft',
    };
  }

  function log(...args) {
    if (nvznAppData.app && nvznAppData.app.logging) {
      console.log('[NVZN]', ...args);
    }
  }

  init();
})();